import React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import type { WrappedFieldProps } from 'redux-form';

type NullableWrappedFieldProps = {
  input?: Partial<WrappedFieldProps['input']>;
  meta?: Partial<WrappedFieldProps['meta']>;
};

type Props = { alwaysDisplayErrors?: boolean } & TextFieldProps & NullableWrappedFieldProps;

const FormTextField = ({
  input = {},
  meta: { touched, error, dirty } = {},
  alwaysDisplayErrors = false,
  helperText,
  ...rest
}: Props) => {
  const showHelperText = dirty || touched || alwaysDisplayErrors;

  const helperTextContent = error || helperText;

  return (
    <TextField
      helperText={showHelperText && helperTextContent}
      {...rest}
      {...input}
      error={!!((touched || alwaysDisplayErrors) && error)}
    />
  );
};

export default FormTextField;
